import React, { useEffect, useState } from "react";
import "./index.css";

const DetailsPage = () => {
  return (
    <div className="dummy-acc-details-container">
      <div className="dummy-acc-details-dropdown-wrapper">
        <select className="dummy-acc-details-dropdown">
          <option>Option 1</option>
          <option>Option 2</option>
        </select>
      </div>

      <div className="dummy-acc-details-section">
        {/* First Box: Remaining Buying Power */}
        <span className="dummy-acc-details-value">EFL</span>
        <div className="dummy-acc-details-column-card">
          <div className="dummy-acc-details-heading">
            Remaining Buying Power
          </div>
          <div className="dummy-acc-details-value">$12,000</div>
        </div>

        {/* Second Box: Two Cards inside one box */}
        <div className="dummy-acc-details-column-card">
          <div className="dummy-acc-details-heading">Trading Overview</div>
          <div className="dummy-acc-details-subrow">
            <div className="dummy-acc-details-subcard">
              <div className="dummy-acc-details-subheading">Open Position</div>
              <div className="dummy-acc-details-value">15</div>
            </div>
            <div className="dummy-acc-details-subcard">
              <div className="dummy-acc-details-subheading">Pending Orders</div>
              <div className="dummy-acc-details-value">7</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsPage;

export const TabButtons = ({
  tabs = ["Overview", "Market Depth", "About"],
  defaultTab = "Overview",
  onTabChange = () => {},
}) => {
  const [activeTab, setActiveTab] = useState(defaultTab);

  useEffect(() => {
    onTabChange(activeTab); // notify parent
  }, [activeTab, onTabChange]);

  return (
    <div className="tab-buttons-wrapper">
      <div className="tab-buttons">
        {tabs.map((tab) => (
          <button
            key={tab}
            className={`tab-btn ${activeTab === tab ? "active" : ""}`}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
    </div>
  );
};
